import { createQueryKeys } from '@lukemorales/query-key-factory';
import { GetCampaignManagersRequestParams } from './campaignManager.types';

import API from 'api/index';

export const campaignManagerQueryKeys = createQueryKeys('campaignManager', {
  getCampaignManagers: (params: GetCampaignManagersRequestParams) => ({
    queryKey: [{ params }],
    queryFn: () => API.CampaignManager.getCampaignManagers(params),
  }),
});
